import {
    populateDefaultItemDataFromTemplateOptions
}                          from "@Common/ui-components/heavy/item-options/minors/populate-default-item-data-from-template-options";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";

export const populateDefaultItemData = (item, {templateOptions, listingUniqueId=undefined}) => chain(
    item,
    (_) => changeNestedValue(_, ["listingUniqueId"], () => listingUniqueId),
    (_) => populateDefaultItemDataFromTemplateOptions(_, {templateOptions}),
);
